// Invoice dates are Unix seconds, never entry dates or date strings.
export const invoiceTimestamp = value => {
  const text = String(value == null ? '' : value).trim();
  const timestamp = Number(text);
  return /^\d+$/.test(text) && Number.isSafeInteger(timestamp) && timestamp > 0 && timestamp <= 253402300799
    ? timestamp : null;
};

const compareId = (a, b) => String(a.memberid).localeCompare(String(b.memberid), 'en', { numeric: true });

export const sortReport = (rows, field, direction) => rows.slice().sort((a, b) => {
  let compared;
  if (field === 'lastpurchase') {
    const left = invoiceTimestamp(a.lastpurchase);
    const right = invoiceTimestamp(b.lastpurchase);
    if (left === null || right === null) {
      return left === right ? compareId(a, b) : left === null ? 1 : -1;
    }
    compared = left - right;
  } else if (field === 'name') {
    compared = String(a.name || '').localeCompare(String(b.name || ''), 'en', { sensitivity: 'base' });
  } else if (field === 'memberid') {
    compared = compareId(a, b);
  } else {
    compared = (Number(a.totalspent) || 0) - (Number(b.totalspent) || 0);
    if (!compared) compared = (Number(a.invoicecount) || 0) - (Number(b.invoicecount) || 0);
  }
  return (compared * (direction === 'asc' ? 1 : -1)) || compareId(a, b);
});
